import { useState } from "react";
import { hotDiscussions } from "@/mocks/home";

export default function DiscussionBoard() {
  const [liked, setLiked] = useState<string[]>([]);
  const [draft, setDraft] = useState("");

  const toggleLike = (id: string) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section id="discussion" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Discussion</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">讨论区</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              高赞分析与反向观点都在这里对照呈现，看热闹之前先看看别人是怎么推理的。
            </p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-user-voice-line text-sm"></i>
            当前在线讨论 3,842 人
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="space-y-4 lg:col-span-2">
            {hotDiscussions.map((post) => {
              const isLiked = liked.includes(post.id);
              return (
                <article key={post.id} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex items-start gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-secondary-500 font-heading text-lg font-black text-background-50">
                      {post.avatar}
                    </span>
                    <div className="flex-1">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <span className="font-heading text-sm font-bold text-foreground-950">{post.name}</span>
                        <span className="text-xs text-foreground-500">{post.time}</span>
                      </div>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-700">{post.content}</p>
                      <div className="mt-3 flex items-center gap-5 text-xs text-foreground-500">
                        <button
                          type="button"
                          onClick={() => toggleLike(post.id)}
                          className={`flex items-center gap-1.5 transition-colors cursor-pointer ${
                            isLiked ? "font-semibold text-primary-600" : "hover:text-primary-600"
                          }`}
                        >
                          <i className={isLiked ? "ri-heart-fill text-base" : "ri-heart-line text-base"}></i>
                          {isLiked ? "已赞同" : post.likes}
                        </button>
                        <span className="flex items-center gap-1.5 cursor-pointer hover:text-primary-600">
                          <i className="ri-chat-3-line text-base"></i>
                          {post.replies} 条回复
                        </span>
                        <span className="flex items-center gap-1.5 cursor-pointer hover:text-primary-600">
                          <i className="ri-share-forward-line text-base"></i>
                          转发
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <aside className="space-y-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-sm font-bold text-foreground-950">发表你的看法</h3>
              <textarea
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                maxLength={500}
                rows={4}
                placeholder="聊聊你的推理线索（最多 500 字）"
                className="mt-3 w-full resize-none rounded-md border border-background-300 bg-background-100 p-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
              ></textarea>
              <div className="mt-2 flex items-center justify-between">
                <span className="text-[11px] text-foreground-400">{draft.length}/500</span>
                <button
                  type="button"
                  className="flex h-9 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
                >
                  <i className="ri-send-plane-fill text-base"></i>
                  发布
                </button>
              </div>
              <p className="mt-2 text-[11px] text-foreground-400">演示站点，内容不会被真实提交。</p>
            </div>

            <div className="rounded-lg bg-gradient-to-br from-accent-500 to-primary-500 p-5 text-background-50">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/25">
                <i className="ri-quill-pen-line text-2xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold">有独家线索？</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/90">
                把你看到的原始素材与时间点整理好投递过来，核实后会第一时间补充进时间线。
              </p>
              <button
                type="button"
                className="mt-4 flex h-10 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 text-sm font-bold text-primary-800 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-add-circle-line text-base"></i>
                进入线索投递
              </button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}